module.exports = __webpack_public_path__ + "static/media/zoom-graphics.25eec40e.svg";